// extracted by mini-css-extract-plugin
export default {"icon_img":"cz","banner_wrapper":"ez","banner":"fz","title_wrapper":"gz","icons":"hz","weekly_freq":"iz","icon":"jz","icon_title":"kz"};
    if(module.hot) {
      // 1711717533327
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  